jQuery(document).ready(function() {
 jQuery("div.open-bio").click(function() {
   jQuery(this).next('.bio-more').toggle();
   jQuery(this).toggleClass('active');
 });
});


if(jQuery( window ).width() < 768)
{  
 jQuery('.footer--block--container').click(function() 
 {
  jQuery(".footer--block--heading").toggleClass('active');
  jQuery(this).closest("div").find("ul").toggleClass('show');
 });
}




jQuery(document).on('change', '.collection_swatches .swatch input[type="radio"]', function() 
{
 var variant_image1 = jQuery(this).data('variant_image1'),
     variant_image2 = jQuery(this).data('variant_image2'),
     variant_url = jQuery(this).data('variant_url');

 jQuery(this).parents('.product--root').find('a').attr('href', variant_url);

 if(typeof variant_image1 != 'undefined') {
   jQuery(this).parents('.product--root').find('.image--root img.lazyautosizes.lazyloaded').attr('srcset', variant_image1);
 }
 if(typeof variant_image2 != 'undefined' && !variant_image2.includes('no-image')) {
   jQuery(this).parents('.product--root').find('.image--root img.hidden').attr('src', variant_image2);
 } else {
   jQuery(this).parents('.product--root').find('.image--root img.hidden').attr('src', variant_image1);
 }
});


jQuery((function(e) {
 e("a.topopup").click((function() 
 {
   return setTimeout((function() 
   {
     s()
   }
    ), 500),
    !1
}
)),
e("div.close").click((function() {
    o()
}
)),
e(this).keyup((function(e) {
    27 == e.which && o()
}
)),
e("div#backgroundPopup").click((function() {
    o()
}
));
var i = 0;
function s() 
{
    0 == i && (e("#toPopup").fadeIn(320),
    e("#backgroundPopup").css("opacity", "0.7"),
    e("#backgroundPopup").fadeIn(1),
//      e("header").css("display", "none"),
    e('header').addClass('fixed-pop'),
    e('main').addClass('fixed-pop-main'),
    e('body').css('overflow', 'hidden'), //Adeed
    e('body').css('overflow-y', 'hidden'), //Adeed
    i = 1)
}
function o() 
{
    1 == i && (e("#toPopup").fadeOut("normal"),
    e("#backgroundPopup").fadeOut("normal"),
    e('header').removeClass('fixed-pop'), 
    e('main').removeClass('fixed-pop-main'),           
    e("header").css("display", "block"),
    e('body').css('overflow', 'auto'), //Adeed
    e('body').css('overflow-y', 'auto'), //Adeed
    i = 0)
}
e(".all_sizes_slider .single-size.active").owlCarousel({
    loop: !0,
    items: 1,
    arrows: !0,
    nav: !0,
    mouseDrag: !0,
    responsiveClass: !0,
    singleItem: true,
    navigation: !0,
    //navigationText: ["<div class='nav-btn prev-slide'>&#8592;</div>", "<div class='nav-btn next-slide'>&#8594;</div>"],
    responsive: {
        0: {
            items: 1,
            loop: !0
        }
    }
}),
  
e(".config__size-row .config__radio-item").click((function() 
{
    e(".config__radio-item").removeClass("active"),
    e(".all_sizes_slider .single-size").removeClass("active");
    var i = e(this).data("size");
    e('.all_sizes_slider .single-size[data-size="' + i + '"]').addClass("active"),
    e(".all_sizes_slider .single-size.active").owlCarousel({
        loop: !0,
        items: 1,
        arrows: !0,
        nav: 1,
        mouseDrag: !0,
        responsiveClass: !0,
        navigation: !0
        //navigationText: ["<div class='nav-btn prev-slide'>&#8592;</div>", "<div class='nav-btn next-slide'>&#8594;</div>"]
    }),
    e(this).addClass("active"),
    e(this).find("input[type=radio]").prop("checked", !0)
}
))
}));


$(document).ready(function(){
 $('.collection_swatches .ctm-color input').removeAttr('checked');
 $('.collection_swatches .preselected label').trigger('click');
});

jQuery(document).ready(function() {
 var currentURL = window.location.href; 
 if(currentURL.includes('products')) {
   setTimeout(function() {
     $('.collection_swatches .preselected label').trigger('click');
   }, 2000);
 } else {
   $('.collection_swatches .preselected label').trigger('click');
 }
});




$(document).ready(function() 
 {
   $('.slideRight').click(function(event) 
   {
     $(this).hide();
     $(this).parents('.collection_swatches').find('.swatch').css('max-width', '100%');
     $(this).parents('.collection_swatches').find('.swatch').animate({scrollLeft: 200}, 800);
   });
 
   $('.collection_swatches .swatch').scroll(function() 
   {
      $(this).css('max-width', '100%');
      $(this).parents('.collection_swatches').find('.slideRight').hide();
   });
 });







//Currency Converter
  class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);



jQuery( document ).ready(function()
{
    if(jQuery(window).width() > 768 )
    {
        let ele  = jQuery('.add-to-cart-panel span.actual-price.money')[0];
        if(ele !== null && ele !== undefined )
        {
            let resizeObserver = new ResizeObserver((e) =>
            {
                let txt = jQuery(ele).text();
                txt = txt.replace('$','');
                txt = txt.replace('£','');
                txt = txt.replace('GBP','');
                txt = txt.replace('CAD','');
                txt = txt.replace('AUD','');  
 
                txt = parseFloat(parseInt(txt)/4).toFixed(2);
                txt = 'or 4 interest-free payments of $'+txt+' with ';
                txt = txt.replace('0with','0 with');  
 
                const afterpay = document.querySelector('#shopify-section-product-color-group afterpay-placement');
                
                if(afterpay !== null && afterpay !== undefined )
                {
                    afterpay.shadowRoot.querySelector('p > span.afterpay-main-text').textContent = txt;
                }
                
            });
            resizeObserver.observe(ele);
        }   
    }
 
    jQuery('#shopify-section-product-color-group .product-header .price span.actual-price.money').on('DOMSubtreeModified', function(e)
    {
        let txt = jQuery(this).text();
        txt = txt.replace('$', '');
        txt = txt.replace('£', '');
        txt = txt.replace('GBP', '');
        txt = txt.replace('CAD', '');
        txt = txt.replace('AUD', '');
 
        txt = parseFloat(parseInt(txt)/4).toFixed(2);
        txt = 'or 4 interest-free payments of $'+txt+'with ';
        txt = txt.replace('0with','0 with');  
        
        const afterpay = document.querySelector('#shopify-section-product-color-group .product-header  afterpay-placement');
        if(afterpay !== null && afterpay !== undefined )
        {
            afterpay.shadowRoot.querySelector('p > span.afterpay-main-text').innerHTML = txt;
        }
    });
});

jQuery( document ).ready(function(){
  $('section.product-grid > .block h2.title,.template--collection section.product-grid h2.font--block-heading,.template--collection .product--root h2.font--block-heading, .partial--product h2').each(function(index, ele) {
    let h = $(this).html().trim(); // Trim leading and trailing whitespaces
    if (h !== null && h !== undefined && typeof h === 'string') {
      h = h.replace('- Short', '');
      h = h.replace('- Regular/Long', '');
      h = h.replace('- XLong', '');
      h = h.replace('- Regular', '');
      h = h.replace('- Long', '');
      
      // Check if the trimmed title starts with "Lacey" and if so, add "Lacey -" at the beginning
      if (h.startsWith('Lacey')) {
        h = 'Lacey ' + h.substr(6).trim(); // Trim again after removing "Lacey"
      }
      $(this).html(h);
   }
 });

  var value = new Date().getTimezoneOffset().toString();
  $('input[name="properties[__shopify_offset]"]').attr('value', value);

  $('.recipient__checkbox').on('click',function(){
    if($(this).is(':checked')) {
      $('.recipient-fields').slideDown();
    } else {
      $('.recipient-fields').slideUp();
    }
  });
});


$( document ).ready(function() 
{
  const url = window.location.href;
  const isCollectionTemplate = $('body').hasClass('template--collection');
  const collectionHeaderExists = $('header.collection--header').length > 0;

  if (isCollectionTemplate && collectionHeaderExists) 
  {
    $('.swim-top-collections-grid .swim-top-collection-grid-item a').each(function(index, ele) 
    {
      const href = $(ele).attr('href');
      const isCurrentPage = url.includes(href);
      if (isCurrentPage) 
      {
        $(ele).addClass('wc-current-page');
      }
    });
  }

  const currentPage = $('.wc-current-page');
  if (currentPage.length) 
  {
    const container = $('.swim-top-collections-grid');
    const windowWidth = $(window).width();
    const imageLeft = currentPage.offset().left;

    if (imageLeft > windowWidth-100 ) 
    {
      let needToScroll = (imageLeft-windowWidth/3);
      container.scrollLeft(needToScroll);
    }
  }

});
$( document ).ready(function() 
{
  const overlay = document.querySelector('.off-canvas--overlay');
  let observer = new MutationObserver((data)=>{ 
    overlayStyleChange();
  });
  const config = { attributes: true , attributesList: ["style"]}

  observer.observe(overlay,config);

  function overlayStyleChange()
  {
    if($('.off-canvas--overlay').is(':visible'))
    {
      $('body').addClass('overlay-enabled')
    }
    else
    {
      $('body').removeClass('overlay-enabled')
    }

    let scrollTop = $(window).scrollTop();
    if(scrollTop > 10)
    {
      $('body').addClass('scroll-top')
    }
    else
    {
      $('body').removeClass('scroll-top')
    }
  }
});


  $( document ).ready(function() 
{
  if($('body').hasClass('template--product'))
  {
    if(window.location.href.indexOf('#sizeguide') != -1)
    {
      document.querySelector('.modal').style.display = 'flex';
      document.body.style.overflowY = 'hidden';
      document.body.classList.add('modal-open');
    }

    //$('#shopify-section-size-chart-popup .modal-body.compare-table').append('<button class="wc-chat">Chat with us!</button>');

    jQuery('button.wc-chat').click(function(e) 
    {
      e.preventDefault();
      $(".modal-header .close").click();
      if($('#gladlyChatTempWrapper button').length)
      {
      $('#gladlyChatTempWrapper button').click();
      }
      else
      {
      $('#gladlyChatDragHandle button').click();
      }
    });

  }
});



$('.partial--product  .image--container img:first-of-type').each(function( index, ele ) 
    {
     let img = jQuery(ele);
     let swatches = $(this).closest('.product--root').find('.collection_swatches .collection_swatch');
     $(swatches).each(function( index, ele ) 
     {
       if($(ele).hasClass('wc-active'))
       {
         let src = $(ele).find('span.swatch-pcp-color').attr('data-img-url'); 
         if(src)
         {
           jQuery(img).attr('src',src);
         }
       }
     });
   });

$(document).ready(function () 
{
  let addToCart = $('body.template--product .pgroup-form #add');
  if (typeof addToCart === 'object') 
  {
    let txt = addToCart.text();
    if (txt === 'Select Options') 
      {
      wcChangeSelectOptionText();
    }

    let radios = $('.swatch.Length input[type=radio], .swatch.Size input[type=radio], .swatch.Cup input[type=radio], .swatch.Inseam input[type=radio]');
    radios.change(function (e) 
    {
      wcChangeSelectOptionText();
    });

    function wcChangeSelectOptionText() 
    {
      let txt = '';
      let notSelected = [];

      if ($('.swatch.Length input[type=radio]').length && $('.swatch.Length input[type=radio]:checked').length == 0) {
        notSelected.push('Length');
      }

      if ($('.swatch.Inseam input[type=radio]').length && $('.swatch.Inseam input[type=radio]:checked').length == 0) {
        notSelected.push('Inseam');
      }

      if ($('.swatch.Size input[type=radio]').length && $('.swatch.Size input[type=radio]:checked').length == 0) {
        notSelected.push('Size');
      }

      if ($('.swatch.Cup input[type=radio]').length && $('.swatch.Cup input[type=radio]:checked').length == 0) {
        notSelected.push('Cup');
      }


      if (notSelected.length > 0) 
      {
        txt = 'Select ';
        $.each(notSelected, function (index, value) {
          txt = txt + value + ', ';
        });
        txt = txt.trim();
        txt = txt.substring(0, txt.length - 1);
      }

      if (txt !== '') 
      {
        addToCart.text(txt);

        $('body #add-to-cart-temp').text(txt);
      }
    }
  }
});

$( document ).ready(function() 
{
  if($('body').hasClass('template--product'))
  {
    function checkIfSoldOutColor()
    {
      let selectedColor =  $('#metafield-color-variants input[type="radio"]:checked');
      if($(selectedColor).closest('.swatch-element.color').hasClass('SoldOut'))
      {  
        let flag = true;
        let len = $('.swatch.Length .swatch-element input[type="radio"]:checked').length;
        if(len===0)
        {
          $('.swatch.Length .swatch-element').each(function( index, ele ) 
          {
            if($(this).is(':visible') && flag)
            {
              $(this).find('input[type="radio"]').click();
              flag = false;
            }
          });
        }
        

        flag = true;
        len = $('.swatch.Size .swatch-element input[type="radio"]:checked').length;
        if(len===0)
        {
          $('.swatch.Size .swatch-element').each(function( index, ele ) 
          {
            if($(this).is(':visible') && flag)
            {
              $(this).find('input[type="radio"]').click();
              flag = false;
            }
          });
        }
        

        flag = true;
        len = $('.swatch.Cup .swatch-element input[type="radio"]:checked').length;
        if(len===0)
        {
          $('.swatch.Cup .swatch-element').each(function( index, ele ) 
          {
            if($(this).is(':visible') && flag)
            {
              $(this).find('input[type="radio"]').click();
              flag = false;
            }
          });
        }
        
      }
    }
    checkIfSoldOutColor();

    $('.swatch.Color .swatch-element').click(function(e) 
    {
      let percentOff = $(this).attr('data-percent-off');
      $('.add-to-cart-panel .product-header .tag-percent-off span').html(percentOff);
    
      setTimeout(function() 
      {
        checkIfSoldOutColor();
      }, 200);
    });

    $('.swatch.Length .swatch-element').click(function(e) 
    {
      setTimeout(function() 
      {
        let len = $('.swatch.Size .swatch-element:not(.soldOut)').length;
        if(len===0)
        {
          let flag = true;
          len = $('.swatch.Size .swatch-element input[type="radio"]:checked').length;
          if(len===0)
          {
            $('.swatch.Size .swatch-element').each(function( index, ele ) 
            {
              if($(this).is(':visible') && flag )
              {
                $(this).find('input[type="radio"]').click();
                flag = false;
              }
            });
          }
          
        }
      }, 200);
    });
  }
});
$( document ).ready(function() {
  $('.cart--no-items a.btn').click(function(e) 
  {
    e.preventDefault();
    $('.off-canvas--viewport .off-canvas--close').click();
  });
});

function wcCheckIfFormLoaded()
{
  let found = false;
  let count = 0;
  let interval = setInterval(() => 
  {  
    if (!found) 
    {
      const element = document.querySelector('.footer--root #mailing-list-module form');
      if (element) 
      {
        clearInterval(interval);
        found = true;
        enableMutationObserver();
      }
    }
    if (count > 9) {
      clearInterval(interval);
    }
    count++;
  }, 500);
}
wcCheckIfFormLoaded();

function wcCheckIfFormLoaded()
{
  console.log(' wcCheckIfFormLoaded ');
  let found = false;
  let count = 0;
  let interval = setInterval(() => 
  {  
    if (!found) 
    {
      const element = document.querySelector('.footer--root #mailing-list-module form');
      if (element) 
      {
        clearInterval(interval);
        found = true;
        enableMutationObserver();
      }
    }
    if (count > 9) {
      clearInterval(interval);
    }
    count++;
  }, 500);
}
wcCheckIfFormLoaded();

function enableMutationObserver()
{
  console.log(' enableMutationObserver ');
  const parent = document.querySelector('.footer--root #mailing-list-module form');
  console.log(' parent ',parent);
  let observer = new MutationObserver((mutations)=>{
    let anchors = document.querySelectorAll('.footer--root #mailing-list-module form a');
    anchors.forEach((anchor)=>{
      if(anchor.textContent == 'Privacy Policy' || anchor.textContent == 'Terms of Service')
      {
        anchor.setAttribute('target','_blank');
      }
    })
  });
  const config = { childList: true, subtree: true };
  observer.observe(parent,config);
}


function wcCheckIfFormLoaded2()
{
  console.log(' wcCheckIfFormLoaded2 ');
  let found = false;
  let count = 0;
  let interval = setInterval(() => 
  {  
    if (!found) 
    {
      const element = document.querySelector('body > div > div.needsclick form');
      if (element) 
      {
        clearInterval(interval);
        found = true;
        enableMutationObserver2();
      }
    }
    if (count > 9) {
      clearInterval(interval);
    }
    count++;
  }, 500);
}
wcCheckIfFormLoaded2();

function enableMutationObserver2()
{
  console.log(' enableMutationObserver2 ');
  const parent = document.querySelector('body > div > div.needsclick form');
  console.log(' parent ',parent);
  let observer = new MutationObserver((mutations)=>{
    let anchors = document.querySelectorAll('body > div > div.needsclick form a');
    anchors.forEach((anchor)=>{
      if(anchor.textContent == 'Privacy Policy' || anchor.textContent == 'Terms of Service')
      {
        anchor.setAttribute('target','_blank');
      }
    })
  });
  const config = { childList: true, subtree: true };
  observer.observe(parent,config);
} 


$( document ).ready(function() 
{
   function checkCheckbox(cb)
   {
     $('.filter-list.fType input[type="checkbox"]').prop('checked', false);
 
     $(cb).click();
 
     let listing = '';
 
     if($(window).width() > 880 )
     {
        $(cb).closest('.filter-list-container').addClass('expanded');
        $(cb).closest('.filter-list.filter-list-u').show(); 
        listing = $('.collection-with-filter .product-grid');
     }
     else
     {
        listing = $('#shopify-section-dynamic-collection-filter');
     }
     
     if($(listing).length)
     {
       let offSet = $(listing).offset().top;
       if($('header.layout--header').length)
       {
          offSet = offSet - $('header.layout--header').outerHeight(); 
          if($(window).width() > 880 )
          {
            offSet = offSet - 40; 
          }
       }
       $('html, body').animate({scrollTop: offSet}, 500);
     }
   }
});

$(document).ready(function() 
{
    let params = new URLSearchParams(window.location.search);
    if(params !== null && params !== undefined )
    {
        let length = params.get('length');
        if(length !== null && length !== undefined )
        {
            length = length.toLowerCase();
            if(length.length > 0)
            {
                $('body .filter-lists #lengths-filter h3').click();
                if(length === 'short')
                {
                    $('body .filter-lists #lengths-filter .fLengths .filter-list-item:first-child label').click();
                }
                if(length === 'xlong')
                {
                    $('body .filter-lists #lengths-filter .fLengths .filter-list-item:nth-child(3) label').click();
                }
                if(length === 'reg/long')
                {
                    $('body .filter-lists #lengths-filter .fLengths .filter-list-item:nth-child(2) label').click();
                }
            }
        }
    }
});

$( document ).ready(function() {
  removeFenixLogo();
});
function removeFenixLogo(){
  let found = false;
  let count = 0;
  let interval = setInterval(() => 
  {  
    if (!found) 
    {
      const ele = document.querySelector('.fenix-provided-options .fenix-logo');
      if (ele) 
      {
        clearInterval(interval);
        found = true;
        $(ele).remove();
      }
    }
    if (count > 11) {
      clearInterval(interval);
    }
    count++;
  }, 500);
}

const el = document.querySelector(".cart--open-right.off-canvas--open");
el.addEventListener("click", () => {
 updateFenixEDD();
});

 function updateFenixEDD(){
    let xhr = new XMLHttpRequest();
    xhr.open('GET', `/cart.json`);
    xhr.onload = function() {
    setTimeout(() => {
       FenixDeliveryEstimates_Cart({
        cartitems: JSON.parse(xhr.response).items,
        shopurl: 'ta3swim.myshopify.com',
      });
    }, 1000)
  };
  xhr.send();
}



$( document ).ready(function() 
{
  const cart = document.querySelector('.off-canvas--right-sidebar .cart--root');
  let observer = new MutationObserver((mutations)=>{ 
     mutations.forEach(function(mutation)
     {
if (mutation.target.classList.contains('fenix-delivery-estimate-cart')) 
{
  changeShippingInfoInSidecart();
}
if (mutation.target.classList.contains('cart--item') ) 
{
  add_decimal_to_am_rec_item_price_drawer();
}
     });  
  });

  let config = { childList: true, subtree: true  }; 
  observer.observe(cart,config);

  function changeShippingInfoInSidecart()
  {
    let out = ''
    $('.fenix-provided-options table tbody tr').each(function( index, ele ) 
    {

      let txt = $(ele).find('td').text().trim();
      if(txt.indexOf('Ground') != -1)
      {
        //out = out + '<div class="wc-row-fenix">' + txt.replace('Ground', "Ship via 'Ground' by ") + '</div>';
      } 
      if(txt.indexOf('2 DAY') != -1)
      {
        out = out + '<div class="wc-row-fenix custom">' + txt.replace('2 DAY', "Get it by ") + ' with 2 Day</div>';
      } 
      if(txt.indexOf('Standard Overnight') != -1)
      {
        out = out + '<div class="wc-row-fenix custom">' + txt.replace('Standard Overnight', "Get it by ") + ' with Standard Overnight</div>';
      }
      
    });
    if(out !== '')
    {
      if($('.fenix-new-style-cart').length)
      {
        $('.fenix-new-style-cart').append(out);
      }
    }


  }
});

  $( document ).ready(function() 
  {
    moveDiagramImage();
  });
  
  
function moveDiagramImage() 
{
  if($('#metafield-color-variants .swatch-element').length) 
  {
    $('#metafield-color-variants .swatch-element').each(function (index, ele) 
    {
      let handle = $(this).attr('data-product_handle');
      if(handle !== null && handle !== undefined && typeof handle === 'string' )
      {
        let largeSlider = $(`.large-images[data-product-image_slider="${handle}"] .slider`);
        let thumbSlider = $(`.thumbs[data-product-image_slider="${handle}"] .slider`);

        if(largeSlider !== null && largeSlider !== undefined && typeof largeSlider === 'object' )
        {
          moveDiagramImageSub(largeSlider, 'main');
        }
        if(thumbSlider !== null && thumbSlider !== undefined && typeof thumbSlider === 'object' )
        {
          moveDiagramImageSub(thumbSlider, 'thumb');
        }
      }
    });
  }
}

  function moveDiagramImageSub(slider,type)
  {
    if( $(slider).length && $(slider).find('img[alt="Diagram"]').length )
    {
      $(slider).slick('unslick');   
      let diagramImageLi = $(slider).find('img[alt="Diagram"]').closest('li');
      diagramImageLi.insertAfter($(slider).find('li:first-child'));    
      if(type == 'main')
      {
        $(slider).slick(getSliderSettingsLarge()); 
      }
      else
      {
        $(slider).slick(getSliderSettingsThumb()); 
      }
      
    } 
  }
  
  function getSliderSettingsLarge()
  {
    return {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      asNavFor: '.slider-nav',
      dots: false,
      adaptiveHeight: true,
      infinite: true,
      nextArrow: '<span class="next">.</span>',
      prevArrow: '<span class="prev">.</span>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots:true,
            arrows:false
          }
        }
      ]
    }
  }

  function getSliderSettingsThumb()
  {
    return {
      slidesToShow: 5,
      slidesToScroll: 5,
      asNavFor: '.slider-for',
      dots: true,
      arrows: false,
      focusOnSelect: true,
      infinite: false,
      vertical: true,
      swipeToSlide: true
    }
  }

$( document ).ready(function() {
  if($(window).width() < 768 )
  {
    $(document).on('click','.boost-sd__button-text-x--close',function(e) 
    {
      e.preventDefault();
      $('.modal--close').click();
    });
  }
});




$( document ).ready(function() 
{
  $('.header--search a').click(function(e) 
  {
    if(!$('body').hasClass('search-click'))
    {
      $('body').addClass('search-click');
      if($('.boost-sd__search-bar-autocomplete').length)
      {
        wcEnableMutationObserverForSuggestionList();
      }
      else
      {
        wcCheckIfSearchSuggestionAvailable();
      }
    }
  });
});

function wcCheckIfSearchSuggestionAvailable()
{
  let found = false;
  let count = 0;
  let interval = setInterval(() => 
  {  
    if(!found) 
    {
      const element = document.querySelector('.boost-sd__search-bar-autocomplete');
      if(element) 
      {
        clearInterval(interval);
        found = true;
        wcEnableMutationObserverForSuggestionList();
      }
    }
    if (count > 15) 
    {
      clearInterval(interval);
    }
    count++;
  }, 500);
}

function wcEnableMutationObserverForSuggestionList()
{
  const element = document.querySelector('.boost-sd__search-bar-autocomplete');
  if(element) 
  {
    let observer = new MutationObserver((mutations)=>
    {
      let flag = true;
      mutations.forEach(function(mutation)
      {   
        if (mutation.target.classList.contains('boost-sd__suggestion-queries-item-title')) 
        {
          flag = false;
        }
      });

      if(flag)
      {
        wcUpdateSuggestionList();
      }
    });
    const config = { childList: true, subtree: true  };
    observer.observe(element,config); 
  }
  wcUpdateSuggestionList();
}

function wcUpdateSuggestionList()
{
  let name = '';

  let ele_li = '#boost-sd__search-widget-init-wrapper ul.boost-sd__instant-search-product-list-items li';

  if(jQuery(window).width() < 768 )
  {
    ele_li = '.boost-sd__search-bar-autocomplete ul.boost-sd__instant-search-product-list-items li';
  } 

  $(ele_li).each(function( index, ele ) 
  {
    let title= $(ele).attr('data-title');
    
    if(title.indexOf('-') != -1)
    {
      title = title.split('-')[0]
      title = title.trim();
      $(ele).find('.boost-sd__suggestion-queries-item-title').text(title);
    }

    if(name == title)
    {
      $(ele).hide();
    }
    else
    {
      name = title;
    }
  });
}


jQuery( document ).ready(function() 
 {  
   const urlParams = new URLSearchParams(window.location.search);
   let size = urlParams.get('size');
   if(size !== null && size !== undefined && typeof size === 'string' )
   {
     size = size.toUpperCase();
     if($('.filter-list.fSizes').length)
     {
       $('.filter-list.fSizes .filter-list-item input').each(function( index, ele ) 
       {
          if($(this).val() == size)
          {
            $(this).closest('input[type="checkbox"]').click();
          }
       });
     }
   }

let discount = urlParams.get('discount');
if(discount !== null && discount !== undefined && typeof discount === 'string' )
{
  discount = discount.toUpperCase().split(',');
  if($('.filter-list.percent-off').length)
  {
    $('.filter-list.percent-off .filter-list-item input').each(function( index, ele ) 
    {
      if(jQuery.inArray($(this).val(), discount) !== -1)
      {
        $(this).closest('input[type="checkbox"]').click();

      }
    });
  }
} 
   
 });



function add_decimal_to_am_rec_item_price(selector) 
{
 $(selector).each(function() 
 {
   let priceText = $(this).text().trim().toLowerCase();
   let currencySymbol = '';
   if (priceText.startsWith('$')) 
   {
     currencySymbol = '$';
     priceText = priceText.replace('$', '');
   }
   else if (priceText.startsWith('£')) 
   {
     currencySymbol = '£';
     priceText = priceText.replace('£', '');
   }
   let price = parseFloat(priceText);
   if (!isNaN(price)) 
   {
     price = price.toFixed(2);
     if (price.endsWith('.00')) 
     {
       price = price.replace('.00', '');
     }
     $(this).text(currencySymbol + price);
   }
 });
}
function add_decimal_to_am_rec_item_price_page()
{
  let found = false;
  let count = 0;
  let interval = setInterval(() => 
  {
    if (!found) 
    {
      const selector = '.layout--main-content span.am_rec_item_price';
      const element = document.querySelector(selector);
      if (element) 
      {
        add_decimal_to_am_rec_item_price(selector);
        
        setTimeout(() => {
          clearInterval(interval);
          found = true;  
        }, 1000);
      }
    }
    if (count >= 20) 
    {
      clearInterval(interval);
    }
    count++;
  }, 500);
}

function add_decimal_to_am_rec_item_price_drawer()
{
  let found = false;
  let count = 0;
  let interval = setInterval(() => 
  {
    if (!found) 
    {
      const selector = '.cart--root span.am_rec_item_price';
      const element = document.querySelector(selector);
      if (element) 
      {
        add_decimal_to_am_rec_item_price(selector);
        
        setTimeout(() => {
          clearInterval(interval);
          found = true;  
        }, 1000);
      }
    }
    if (count >= 20) 
    {
      clearInterval(interval);
    }
    count++;
  }, 500);
}
add_decimal_to_am_rec_item_price_page();
add_decimal_to_am_rec_item_price_drawer();
 
$('#metafield-color-variants input[type=radio]').change(function() 
{
  add_decimal_to_am_rec_item_price_page();
});

$( document ).ready(function() 
  {
    const urlParams = new URLSearchParams(window.location.search);
    const option = urlParams.get('category');
    if(option !== null && option !== undefined && typeof option === 'string' )
    {
      $('.swim-top-collections-grid .swim-top-collection-grid-item a').each(function(index, ele) 
      {
        const href = $(this).attr('href').replace('#', '');
        console.log('href : ', href);
          if(option === href)
          {
            $(ele).addClass('wc-current-page');
            setTimeout(() => 
            {
              $(ele).closest('a').click();
            }, 100);
          }
      });
    }
 });



function wcAppendBannerWithCondition() 
{
  const pos = 0; 
  let bannerImages = [];


  if ($("body.page--mega-sculpting-swimwear").length) 
  {
    let pageUrl = 'https://ta3swim.com/collections/shaping-dresses';
    let banner = "https://cdn.shopify.com/s/files/1/0029/5026/6925/files/Shaping_Dresses_by_TA3.jpg?v=1751659697";

    let pageUrl2 = 'https://ta3swim.com/collections/shaping-tops';
    let banner2 = "https://cdn.shopify.com/s/files/1/0029/5026/6925/files/shaping-tops-by-ta3.jpg?v=1747267415";

    bannerImages = 
    [
      {
        image: '<div class="block width--medium-3 product-banner"><a href="'+pageUrl+'"><img src="'+banner+'" alt="TA3 Mega Sculpting Shaping Dresses" style="margin-bottom:20px;"></a></div>',
        pos: 18
      },
      {
        image: '<div class="block width--medium-3 product-banner"><a href="'+pageUrl2+'"><img src="'+banner2+'" alt="TA3 Mega Sculpting Shaping Tops" style="margin-bottom:20px;"></a></div>',
        pos: 25
      }
    ];
  }

  if ($("body.page--shaping-dresses").length) 
  {
    let pageUrl = 'https://ta3swim.com/collections/summer-2025-collection';
    let banner = "https://cdn.shopify.com/s/files/1/0029/5026/6925/files/mega-sculpting-swimwear-by-ta3.jpg";

    bannerImages = 
    [
      {
        image: '<div class="block width--medium-3 product-banner"><a href="'+pageUrl+'"><img src="'+banner+'" alt="Shop TA3 Mega Sculpting Swimwear" style="margin-bottom:20px;"></a></div>',
        pos: 7
      }
    ];
  }

  if (Array.isArray(bannerImages) && bannerImages.length > 0) 
  {
    bannerImages.forEach(banner => 
    {
      let image = banner.image;
      let pos = banner.pos;
      if (image && image.length > 0) 
      {
        appendBanner(image, pos);
      }
    });
  }
}

function appendBanner(image, pos) 
{
  if (image !== "") 
  {
    $(".product-banner").length && $(".product-banner").remove();
    setTimeout(() => 
    {
      if ($('.filter-list-container input[type="checkbox"]:checked').length) 
      {
        if (!$("#wc-all-hidder").is(":visible")) 
        {
          $(".product-grid").append(image);
        }
      }
      else 
      {
        $(".product-grid .block:nth-child(" + pos + ")").after(image);
      }
    }, 250);
  }
}

  
  $(document).ready(function () 
  {
    wcAppendBannerWithCondition();
    $('.filter-list-container input[type="checkbox"]').change(function() 
    {
      wcAppendBannerWithCondition();  
    });
  });
 
  $(document).on('click', '#wc-all-hidder button, .wc-clear-all,.filter-lists .reset-all', function (e)
  {
    wcAppendBannerWithCondition();
  });



$( document ).ready(function() 
  {
    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get('category');
    if(category !== null && category !== undefined && typeof category === 'string' )
    {
      if($('.page--all-sale .filter-lists .fType').length)
      {
        $('.page--all-sale .filter-lists .fType input').each(function( index, ele ) 
        {
          if($(this).val().toUpperCase() === category.toUpperCase())
          {
            $(this).closest('label').click();
            $(this).closest('.filter-list-container').find('h3.toggle-size').click();
          }
        });
      }
    }
  });


$(document).ready(function () 
{
  const cart = document.querySelector('.off-canvas--right-sidebar .cart--root');
  if(cart)
  {
    let observer = new MutationObserver((mutations)=>
    { 
      let flag = false;
      let mutationType = null;
      mutations.forEach((mutation) => 
      {
        if(mutation.target.classList.contains('cart--item') )
        {
          flag = true;
          mutationType = 'cart--item';
        }

        if(mutation.target.classList.contains('apz-widget-root-container'))
        {
          flag = true;
          mutationType = 'FBT';
        }
      });

      if(flag )
      {
        setTimeout(() => {
          cartDrawerStickyHeaderFooter(mutationType);  
        }, 250); 
      }

    });
    let config = { childList: true, subtree: true  }; 
    observer.observe(cart,config);
  }


  $('.cart--open-right,a.header--cart-count.off-canvas--open').click(function(e) 
  {
    setTimeout(() => {
      cartDrawerStickyHeaderFooter('button-click');  
    }, 500); 
  });
  

  function cartDrawerStickyHeaderFooter(mutationType) 
  {

    const cartForm = $('.off-canvas--right-sidebar .cart--form');
    if(mutationType == 'cart--item' )
    {
      if($('.cart--form.cart--item-mutation-done').length > 0)
      {
        return;
      }
      else
      {
        $(cartForm).addClass('cart--item-mutation-done');
      }
    }


    if(mutationType == 'FBT' )
    {
      if( $('.cart--form.FBT-mutation-done').length > 0)
      {
        return;
      }
      else
      {
        $(cartForm).addClass('FBT-mutation-done');
      }
    }
    
    cartForm.css('overflow-y','hidden');
    cartForm.css('max-height',  'unset');

    const drawerHeight    = $('.off-canvas--right-sidebar').outerHeight();
    const cartRootHeight  = $('.off-canvas--right-sidebar .cart--root').outerHeight();
    const headerHeight    = $('.off-canvas--right-sidebar .cart--header').outerHeight();      
    const buttonHeight    = $('.off-canvas--right-sidebar .cart--footer .cart--nav').outerHeight();

    const maxHeight = drawerHeight - (headerHeight + buttonHeight);
    
    if (drawerHeight  < cartRootHeight || 1==1) 
    {  
      cartForm.css('overflow-y','scroll');
      cartForm.css('max-height', maxHeight + 'px');
    }    
  }
});

$(document).ready(function() 
{
  if($('body.template--product').length)
  {
    function updateColorStr()
    {
      let txt = $('#metafield-color-variants .swatch_value-color').text();
      if(txt == 'contour dark/cherry/oat') 
      {
        txt = txt.replace('/', ' ');
        $('#metafield-color-variants .swatch_value-color').text(txt);
      }
    }
    updateColorStr();
    $('#metafield-color-variants input[type=radio]').change(function() 
    {
      updateColorStr();
    });
  }
});

document.addEventListener('DOMContentLoaded', function ()
{
  const trigger = document.querySelector('.klaviyo_form_trigger');
  if (trigger)
  {
    trigger.addEventListener('click', function ()
    {
      window._klOnsite = window._klOnsite || [];
      if (jQuery(window).width() > 600)
      {
        window._klOnsite.push(['openForm', 'VvhKv7']);
      }
      else
      {
        window._klOnsite.push(['openForm', 'YffGZM']);
      }
    });
  }
});

 $(document).ready(function () {
    const onesize = $('.pgroup-form .swatch.Size .swatch-element.one-size');
    if(onesize.length === 1)
    {
      $(onesize).find('label').click();
    }
  });




$(document).ready(function () 
{
  const urlParams = new URLSearchParams(window.location.search);
  const filters = {
    'product-type': 'fProductType',
    'butt-coverage': 'fButtCoverage',
    'bust-support': 'fBustSupport'
  };

  Object.entries(filters).forEach(([param, filter]) => 
  {
    let qstring = urlParams.get(param);

    if (typeof qstring === 'string' && qstring.trim() !== '') 
    {
      qstring = qstring.split(',').map(cat => cat.trim().replace(/\s+/g, '-'));
      qstring.forEach(qstr => selectFilters(filter, qstr));
    }
  });

  function selectFilters(filter, qstr) 
  {
    const filterSelector = `.filter-lists .${filter}`;
    const filterInputSelector = `${filterSelector} input`;

    if ($(filterSelector).length) 
    {
      $(filterInputSelector).each(function () 
      {
        const this_val = $(this).val().toLowerCase().trim().replace(/\s+/g, '-');

        if (this_val === qstr) 
        {
          $(this).closest('input[type="checkbox"]').click();


          setTimeout(() => 
          {
            const productBanner = $('.product-grid .product-banner');
            if (productBanner.length > 1) 
            {
              productBanner.not(':first').remove();
            }
          }, 300);


          if($(window).width() > 880 )
          {
          const container = $(this).closest('.filter-list-container');
          if (!container.hasClass('expanded')) 
          {
            container.find('h3.toggle-size').click();
          }
          } 
        }
      });
    }
  }
});

$(document).ready(function() 
{
  $('#shopify-section-dynamic-collection-filter .filter-list-container').each(( index, ele )=> 
  {
    const len = $(ele).find('.filter-list .filter-list-item:not([style="display: none;"])').length;
    if( len == 1)
    {
      $(ele).hide();
    }
  });
});

$(document).ready(function() {
  if ($(window).width() <= 880) 
  {
    let mobileFilter = $('.collection-with-filter .shopify-section').outerHeight();
    if(mobileFilter !== null && mobileFilter !== undefined )
    {
      $('.collection-with-filter .filter-list-container .filter-list-u').css('top', mobileFilter);
    }
  }
});

function checkIfLengthSwatchIsReady()
{
  let found = false;
  let attempts = 0;
  const maxAttempts = 30;
  const intervalTime = 100;
  let interval = setInterval(() => 
  {  
    if (!found) 
    {
      const LengthSwatch = document.querySelector('.add-to-cart-panel .pgroup .swatch.Length');
      const sizeSwatch = document.querySelector('.add-to-cart-panel .pgroup .swatch.Size');
      if (LengthSwatch || sizeSwatch) 
      {
        clearInterval(interval);
        found = true;
        wcSelectRegularLength(LengthSwatch, sizeSwatch);
      }
    }
    if (attempts >= maxAttempts) 
    {
      clearInterval(interval);
    }
    attempts++;
  }, intervalTime);

  function wcSelectRegularLength(LengthSwatch, sizeSwatch)
  {
    if(LengthSwatch)
    {
        let $lengthFound = false;
      $(LengthSwatch).find('.ctm-length').each( function()
      {
        lengthTxt = $(this).attr('data-value').trim().replace(/\s+/g, '').toLowerCase();
        if(!$lengthFound && (lengthTxt == 'regular' || lengthTxt == 'regular/long' || lengthTxt == 'reg/long'))
        {
            console.log(`%clengthTxt ${lengthTxt}`,'color:#fff;background-color: #00f;padding:5px;');
            $lengthFound = true;
          $(this).find('input[type=radio]').click();       
        }
      });
    }
    else if( sizeSwatch !== null && sizeSwatch !== undefined )
    {
      if( pGroup !== null && pGroup !== undefined )
      {
        const colorInput = document.querySelector(".pgroup-input[data-pgroup-input='color']:checked");
        const colorValue = colorInput ? colorInput.value : null;

        if( colorValue !== null && colorValue !== undefined )
        {
          const lastSwatch = document.querySelector(".pgroup-swatches .swatch:last-child");   
          if( lastSwatch.classList.contains('Size') )
          {
            const lastSwatchInputs = lastSwatch.querySelectorAll(".pgroup-input");
            lastSwatchInputs.forEach(input => {
              const variantID = pGroup[colorValue]['option_lookup'][input.value];
              if( variantID !== null && variantID !== undefined )
              {
                const variantObject = pGroup[colorValue]['variants'][variantID];
                if( variantObject !== null && variantObject !== undefined )
                {
                  if( variantObject['available'] != 'true' )
                  {
                    input.parentElement.classList.add('soldOut');
                  }
                }
              }
            });
          }
        }
      }
    }
    else
    {

    }      
  }
}
checkIfLengthSwatchIsReady();



$(document).ready(function ()
{
  const cart = document.querySelector('.off-canvas--right-sidebar .cart--root');
  if(cart)
  {
    let observer = new MutationObserver((mutations)=>
    {
      mutations.forEach(function(mutation)
      {
      if (mutation.target.classList.contains('cart--item') || mutation.target.classList.contains('cart--root'))
      {
      removePreOrderInfo();    
      }
      });
    });
 
    let config = { childList: true, subtree: true  };
    observer.observe(cart,config);
 
    function removePreOrderInfo()
    {
      $('.off-canvas--right-sidebar .cart--root .cart--body .cart--item ').each(function( index, ele )
      {
        if($(this).find('.cart--item-properties'))
        {
          let txt = $(this).find('.cart--item-properties').text().trim();
          if(txt.includes('Purple Dot Pre-order'))
          {
            txt = txt.replace('Purple Dot Pre-order :', 'Pre-order:');
            $(this).find('.cart--item-properties').text(txt);
          }
        }
      });
    }
    removePreOrderInfo();
  }
});


 $(document).ready(function () 
 {
    $('.wc-slides video').each(function( index, ele ) 
    {
        let src = $(this).attr('data-src');
        if(src)
        {
          $(this).attr('src',src);
        }
    });

    let slider = '.wc-slides';

    if(slider !== null && slider !== undefined )
    {
        $(slider).on('init', function(slick) 
        {
            if(!$('.slider-play-pause').length)
            {
                $(slider).append('<button class="slider-play-pause">pause</button>');
            }
        });

        $(slider).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 4000,
            arrows: false,
            dots: true,
        });

        $(document).on('click','.slider-play-pause',function(e) 
        {
            e.preventDefault();
            if ($(this).html() == 'pause')
            {
                $(slider).slick('slickPause')
                $(this).html('play')
                $(this).addClass('play')
            } 
            else 
            {
                $(slider).slick('slickPlay')  
                $(this).html('pause') 
                $(this).removeClass('play')
            }
        });
    }
});

function checkIfEmptyAnchorIsReady()
{
    let found = false;
    let attempts = 0;
    const maxAttempts = 10;
    const intervalTime = 250;
    
    const eleSelector = 'ul.slider.slider-nav li a:not([href])';

    let interval = setInterval(() => 
    {  
        if (!found) 
        {
            const element = document.querySelector(eleSelector);
            if (element) 
            {
                //console.clear();
                clearInterval(interval);
                found = true;
                addHrefAttrToAnchor();
                setTimeout(() => {
                    addHrefAttrToAnchor();
                }, 1000);
            }
        }
        if (attempts >= maxAttempts) 
        {
            clearInterval(interval);
        }
        attempts++;
    }, intervalTime);
    
    function addHrefAttrToAnchor()
    {
        $('a:not([href])').each(( index, ele )=> 
        {
            $(ele).attr('href', '#');
            $(ele).removeAttr('target');
        });   
    }
    $('body').delegate('ul.slider.slider-nav li a[href="#"]','click',function(e)
    {
        e.preventDefault();
    });
}
checkIfEmptyAnchorIsReady();

$(document).ready(function() 
{
    const $searchBar = $('.search--root .search--bar');
    if( $searchBar.length > 0)
    {
        $searchBar.append('<button type="submit" class="search--btn"></button>');
        $('.search--btn').on('click', function(e)
        {
            e.preventDefault();
            const $txtboxSearch = $('.search--root input.search--textbox');
            if( $txtboxSearch.length > 0 )
            {
                const txt = $txtboxSearch.val().trim().toLowerCase().replace(/ /g, '+');
                if( txt !== null && txt !== undefined )
                {
                    const url = `https://ta3swim.com/search?q=${txt}`;
                    window.location.href = url;
                }
            }
        });
    }
});

if (window.innerWidth > 768) {
$(document).ready(function(){
  $('.product-grid.new-ar').slick({
  slidesToShow: 5,
  slidesToScroll: 2,
  touchThreshold:100,
  infinite: true,
  dots: false,
  arrows: true,
  centerMode: false,
    responsive: [{
    breakpoint: 1000,
    settings: {
      slidesToShow: 3
    }
  }]
  });
});
  }